{
    "Policies_Header.title": "Policies",

    "Policies_Header.nav.all": "All",
    "Policies_Header.nav.incomplete": "Incomplete",
    "Policies_Header.nav.bound": "Bound",
    "Policies_Header.nav.board": "Board",

    "Policies_Header.filter.brokerage": "Brokerage",
    "Policies_Header.filter.assignedTo": "Assigned To",

    "Policies_Header.filter.showSuspended": "Show suspended",
    "Policies_Header.filter.showSuspendedDescription": "This option will show suspended leads in addition to any other filtering criteria.",
    "Policies_Header.filter.showUnassigned": "Show unassigned",
    "Policies_Header.filter.showUnassignedDescription": "This option will show unassigned leads in addition to any other filtering criteria."
}
